import * as React from 'react';

interface IDownloadIcon {
  className?: string;
}

export const PrintIcon = (props: IDownloadIcon) => (
  <svg className={props.className || ''} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    {/* tslint:disable-next-line:max-line-length */}
    <path fill="currentColor" fillRule="evenodd" d="M10 10V7.7a.7.7 0 0 0-.7-.7H2.7a.7.7 0 0 0-.7.7V10H1a1 1 0 0 1-1-1V3.7A.7.7 0 0 1 .7 3h10.6a.7.7 0 0 1 .7.7V9a1 1 0 0 1-1 1h-1zM3.7 0h4.6a.7.7 0 0 1 .7.7v.6a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V.7a.7.7 0 0 1 .7-.7zm0 8h4.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V8.7a.7.7 0 0 1 .7-.7z"/>
  </svg>
);
